import { Component, OnInit } from '@angular/core';
import { pageAnimation } from '@app/core/animations/element.animations';
import { AuthService } from '@app/services/auth.service';

@Component({
    selector: 'app-registration-successful',
    templateUrl: './registration-successful.component.html',
    styleUrl: './registration-successful.component.scss',
    animations: [pageAnimation]
})
export class RegistrationSuccessfulComponent implements OnInit{

    ngOnInit(): void {
        setTimeout(() => {
            this.auth.login();
        }, 2000);
    }

    constructor(private auth: AuthService) {
    }
}
